import { useState } from 'react'

import { scrollToTop } from '@/utils/domUtils'

export function useWorkaround() {
  const [scrollOffset, setScrollOffset] = useState(0)

  // [Workaround]
  // 1. iOS에서 select와 날짜 선택 영역이 하단에 노출되면서
  //    화면을 밀어올리고 scroll이 이동되지 않은 이슈가 있어서 강제로 이전 scroll 위치로 이동
  const restoreScrollOffset = () => {
    const offset = scrollOffset || window.pageYOffset

    setTimeout(() => {
      scrollToTop(offset)
    }, 300)
  }

  return { setScrollOffset, restoreScrollOffset }
}
